import * as React from 'react';

export function SvgMute(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.533 5.099A1 1 0 0112.1 6v12.6a1 1 0 01-1.625.78L6.25 16H3a1 1 0 01-1-1V9.6a1 1 0 011-1h3.25l4.225-3.38a1 1 0 011.058-.121zM10.1 8.08l-2.875 2.3a1 1 0 01-.625.219H4V14h2.6a1 1 0 01.625.22l2.875 2.3V8.08z"
        fill="currentColor"
      />
    </svg>
  );
}
